"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
var pino_1 = __importDefault(require("pino"));
var ts_pattern_1 = require("ts-pattern");
var GelfLevels;
(function (GelfLevels) {
    GelfLevels[GelfLevels["emergency"] = 0] = "emergency";
    GelfLevels[GelfLevels["alert"] = 1] = "alert";
    GelfLevels[GelfLevels["critical"] = 2] = "critical";
    GelfLevels[GelfLevels["error"] = 3] = "error";
    GelfLevels[GelfLevels["warning"] = 4] = "warning";
    GelfLevels[GelfLevels["notice"] = 5] = "notice";
    GelfLevels[GelfLevels["info"] = 6] = "info";
    GelfLevels[GelfLevels["debug"] = 7] = "debug";
})(GelfLevels || (GelfLevels = {}));
var PinoToGelfLevelFormatter = function (level, number) {
    return ts_pattern_1.match(level)
        .with('trace', function () { return ({ name: level, level: GelfLevels.debug }); })
        .with('debug', function () { return ({ name: level, level: GelfLevels.debug }); })
        .with('info', function () { return ({ name: level, level: GelfLevels.info }); })
        .with('warn', function () { return ({ name: level, level: GelfLevels.warning }); })
        .with('error', function () { return ({ name: level, level: GelfLevels.error }); })
        .with('fatal', function () { return ({ name: level, level: GelfLevels.emergency }); })
        .otherwise(function () { return ({ name: level, level: GelfLevels.notice }); });
};
var PinoLogger = /** @class */ (function () {
    function PinoLogger() {
        var prettyPrintEnv = process.env.LOG_PRETTY ? process.env.LOG_PRETTY === 'true' : undefined;
        var logLevelEnv = process.env.LOG_LEVEL;
        var logLevelDefaults = ['development', 'localproduction'].includes(process.env.ENV) ? 'trace' : 'warn';
        this.pino = pino_1.default({
            prettyPrint: prettyPrintEnv || ['development', 'localproduction'].includes(process.env.ENV),
            level: logLevelEnv || logLevelDefaults,
            redact: ['req.headers.authorization', "metadataMap.authorization"],
            formatters: {
                level: PinoToGelfLevelFormatter
            }
        });
    }
    PinoLogger.prototype.trace = function (message, ctx) {
        this.pino.trace({ msg: message, ctx: ctx });
    };
    PinoLogger.prototype.debug = function (message, ctx) {
        this.pino.debug({ msg: message, ctx: ctx });
    };
    PinoLogger.prototype.log = function (message, ctx) {
        this.debug(message, ctx);
    };
    PinoLogger.prototype.info = function (message, ctx) {
        this.pino.info({ msg: message, ctx: ctx });
    };
    PinoLogger.prototype.warn = function (message, ctx) {
        this.pino.warn({ msg: message, ctx: ctx });
    };
    PinoLogger.prototype.error = function (message, ctx) {
        if (typeof message === 'string' && ctx instanceof Error) {
            return this.pino.error(pino_1.default.stdSerializers.err(ctx), message);
        }
        if (message instanceof Error) {
            return this.pino.error(pino_1.default.stdSerializers.err(message), message.message, { ctx: ctx });
        }
        this.pino.error({ msg: message, ctx: ctx });
    };
    PinoLogger.prototype.fatal = function (message, ctx) {
        if (typeof message === 'string' && ctx instanceof Error) {
            return this.pino.fatal(pino_1.default.stdSerializers.err(ctx), message);
        }
        if (message instanceof Error) {
            return this.pino.fatal(pino_1.default.stdSerializers.err(message), message.message, { ctx: ctx });
        }
        this.pino.fatal({ msg: message, ctx: ctx });
    };
    return PinoLogger;
}());
exports.Logger = new PinoLogger();
